// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"083f6907","833":"d90f1e59"}[chunkId] + ".chunk.js";
};